import { Component } from "@angular/core";
// import {select} from '@angular-redux/store';
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { ConfigActions } from "../../ThemeOptions/store/config.actions";
import { ThemeOptions } from "../../theme-options";
import {
  animate,
  query,
  style,
  transition,
  trigger,
} from "@angular/animations";

@Component({
  selector: "app-apps-layout",
  templateUrl: "./apps-layout.component.html",
  animations: [
    trigger("architectUIAnimation", [
      transition("* <=> *", [
        query(":enter, :leave", [
          style({
            opacity: 0,
            display: "flex",
            flex: "1",
            transform: "translateY(-20px)",
            flexDirection: "column",
          }),
        ]),
        query(":enter", [
          animate(
            "600ms ease",
            style({ opacity: 1, transform: "translateY(0)" })
          ),
        ]),
        query(
          ":leave",
          [
            animate(
              "600ms ease",
              style({ opacity: 0, transform: "translateY(-20px)" })
            ),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
  standalone: false,
})
export class AppsLayoutComponent {
  //   @select("config") public config$: Observable<any>;
  public config$: Observable<any>;
  constructor(
    public globals: ThemeOptions,
    public configActions: ConfigActions,
    private store: Store<{ config: any }>
  ) {
    this.config$ = this.store.pipe(select("config"));
  }

  toggleSidebarMobile() {
    this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
  }
}
